<template>
  <div>
    <h3 class="text-primary"><i class="fa fa-headphones me-2"></i> {{ $t("supportTickets.myTickets") }}</h3>
    <p class="text-muted">{{ $t("supportTickets.info") }}</p>
<!-- Formular Creare Tichet -->
<div class="card shadow-sm p-3 mb-4">
  <h5><i class="fa fa-plus-circle me-2"></i> {{ $t("supportTickets.createNew") }}</h5>
  <div class="mb-3">
    <label class="form-label">{{ $t("supportTickets.subject") }}</label>
    <input v-model="newTicket.subject" class="form-control" :placeholder="$t('supportTickets.subjectPlaceholder')" />
  </div>
  <div class="mb-3">
    <label class="form-label">{{ $t("supportTickets.message") }}</label>
    <textarea v-model="newTicket.message" class="form-control" rows="3" :placeholder="$t('supportTickets.messagePlaceholder')"></textarea>
  </div>
  <button class="btn btn-success w-100" @click="submitTicket">
    <i class="fa fa-paper-plane me-1"></i> {{ $t("supportTickets.sendTicket") }}
  </button>
</div>

    <!-- Listă Tichete -->
    <div class="table-responsive" v-if="tickets.length">
      <table class="table table-striped table-hover rounded">
        <thead class="bg-primary text-white">
          <tr class="text-center">
            <th>#</th>
            <th><i class="fa fa-tag me-1"></i> {{ $t("supportTickets.subject") }}</th>
            <th><i class="fa fa-flag me-1"></i> {{ $t("supportTickets.status") }}</th>
            <th><i class="fa fa-calendar me-1"></i> {{ $t("supportTickets.date") }}</th>
            <th><i class="fa fa-cogs me-1"></i> {{ $t("supportTickets.actions") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="ticket in tickets" :key="ticket.id" class="text-center">
            <td>#{{ ticket.id }}</td>
            <td>{{ ticket.subject }}</td>
            <td>
              <span :class="getStatusClass(ticket.status)">
                {{ getStatusText(ticket.status) }}
              </span>
            </td>
            <td>{{ formatDate(ticket.created_at) }}</td>
            <td>
              <button class="btn btn-outline-primary btn-sm" @click="toggleDetails(ticket.id)">
                <i class="fa fa-eye me-1"></i> {{ expandedTicket === ticket.id ? $t("supportTickets.hide") : $t("supportTickets.viewDetails") }}
              </button>
            </td>
          </tr>
          <!-- Detalii tichet expandabile -->
          <tr v-if="expandedTicket" class="ticket-details">
            <td colspan="5">
              <div class="details-box mt-3">
                <h5><i class="fa fa-ticket me-2"></i> {{ selectedTicket?.subject || "Tichet" }}</h5>
                <p><strong>{{ $t("supportTickets.status") }}:</strong> {{ getStatusText(selectedTicket?.status || "open") }}</p>
                <p><strong>{{ $t("supportTickets.initialMessage") }}:</strong> {{ selectedTicket?.message || "Se încarcă..." }}</p>

                <h5 class="mt-4"><i class="fa fa-comments me-2"></i> {{ $t("supportTickets.responses") }}</h5>
                <ul class="list-group response-list">
                  <li v-if="!selectedTicket?.responses?.length" class="list-group-item text-muted">
                    {{ $t("supportTickets.noResponsesYet") }}
                  </li>
                  <li v-for="response in selectedTicket?.responses || []" :key="response.created_at" class="list-group-item">
                    <div>
                      <strong class="d-block text-primary">
                        <i class="fa fa-user me-1"></i> {{ response.sender === "client" ? "Tu" : "Suport" }}
                      </strong>
                      <p class="mb-1">{{ response.message }}</p>
                      <small class="text-muted"><i class="fas fa-clock me-1"></i> {{ formatDate(response.created_at) }}</small>
                    </div>
                  </li>
                </ul>

                <p class="text-muted mt-3"><i class="fa fa-globe me-1"></i> {{ $t("supportTickets.languageNotice") }}</p>

                <textarea v-model="newResponse" class="form-control mt-2" placeholder="Adaugă răspuns..." rows="3"></textarea>
                <button class="btn btn-primary mt-2 w-100" @click="addResponse(selectedTicket?.id)">
                  <i class="fa fa-paper-plane me-1"></i> {{ $t("supportTickets.send") }}
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Dacă nu sunt tichete -->
    <div class="alert alert-warning text-center" v-else>
      <i class="fa fa-info-circle me-2"></i> {{ $t("supportTickets.noTickets") }}
    </div>
  </div>
</template>

<style scoped>
/* Stilizare tabel și butoane */
.table {
  border-radius: 8px;
  overflow: hidden;
}

.text-primary {
  color: #0056b3 !important;
}

.btn-primary {
  background-color: #0056b3;
  border: none;
  transition: background 0.3s ease;
}

.btn-primary:hover {
  background-color: #0056b3;
}

/* Casetă detalii tichet */
.details-box {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 10px;
  border-left: 4px solid #0056b3;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

/* Lista de răspunsuri */
.response-list .list-group-item {
  border-left: 4px solid #0056b3;
  border-radius: 8px;
  background: #ffffff;
  padding: 12px;
  margin-bottom: 5px;
}

/* Rand detalii tichet */
.ticket-details td {
  padding: 0 !important;
}
</style>

<script>
import axios from "axios";

export default {
  name: "SupportTickets",
  data() {
    return {
      tickets: [],
      selectedTicket: null,
      expandedTicket: null,
      newResponse: "",
      newTicket: {
  subject: "",
  message: "",
}
    };
  },
  async mounted() {
    await this.fetchTickets();
  },
  methods: {
    getStatusText(status) {
      const statuses = {
        open: this.$t("supportTickets.statusOpen"),
        in_progress: this.$t("supportTickets.statusInProgress"),
        resolved: this.$t("supportTickets.statusResolved"),
        closed: this.$t("supportTickets.statusClosed"),
      };
      return statuses[status] || this.$t("supportTickets.statusUnknown");
    },async submitTicket() {
  if (!this.newTicket.subject.trim() || !this.newTicket.message.trim()) {
    alert(this.$t("supportTickets.emptyTicketError"));
    return;
  }

  try {
    await axios.post("https://api.feribot-eurobac.ro/client/api/tickets/create", this.newTicket, {
      withCredentials: true,
    });

    this.newTicket.subject = "";
    this.newTicket.message = "";
    await this.fetchTickets();

    alert(this.$t("supportTickets.ticketCreated"));
  } catch (error) {
    console.error("Eroare la crearea tichetului:", error);
    alert(this.$t("supportTickets.ticketError"));
  }
},
    formatDate(dateString) {
      if (!dateString) return "N/A";
      const date = new Date(dateString);
      return date.toLocaleDateString("ro-RO", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },
    async fetchTickets() {
      try {
        const response = await axios.get("https://api.feribot-eurobac.ro/client/api/tickets/", {
          withCredentials: true,
        });
        this.tickets = response.data.tickets;
      } catch (error) {
        console.error("Eroare la preluarea tichetelor:", error);
      }
    },    getStatusClass(status) {
      return {
        open: "badge bg-warning text-dark",
        in_progress: "badge bg-primary",
        resolved: "badge bg-success",
        closed: "badge bg-danger",
      }[status];
    },

    async toggleDetails(ticketId) {
      if (this.expandedTicket === ticketId) {
        this.expandedTicket = null;
        this.selectedTicket = null;
      } else {
        this.expandedTicket = ticketId;
        await this.viewTicket(ticketId);
      }
    },
    async viewTicket(ticketId) {
      try {
        this.selectedTicket = { subject: "Se încarcă...", responses: [] };

        const response = await axios.get(`https://api.feribot-eurobac.ro/client/api/tickets/${ticketId}/`, {
          withCredentials: true,
        });

        this.selectedTicket = response.data;
      } catch (error) {
        console.error("Eroare la preluarea detaliilor tichetului:", error);
        this.selectedTicket = null;
      }
    },
    async addResponse(ticketId) {
      if (!this.newResponse.trim()) {
        alert(this.$t("supportTickets.emptyMessageError"));
        return;
      }

      try {
        await axios.post(
          `https://api.feribot-eurobac.ro/client/api/tickets/${ticketId}/response/`,
          { message: this.newResponse },
          { withCredentials: true }
        );

        this.selectedTicket.responses.push({
          sender: "client",
          message: this.newResponse,
          created_at: new Date().toISOString(),
        });

        this.newResponse = "";
      } catch (error) {
        console.error("Eroare la trimiterea răspunsului:", error);
      }
    },
  },
};
</script>


  